/**
 * Small badge that renders the Afterpay wordmark on its signature mint background.
 * Kept intentionally simple (SVG-in-JSX) so we don't ship a bitmap asset.
 * Colours match Afterpay's own brand guidelines (mint #B2FCE4, ink #000).
 */
function AfterpayLogo({ height = 14 }) {
  return (
    <span
      aria-label="Afterpay"
      className="inline-flex items-center justify-center font-black tracking-tight"
      style={{
        height,
        padding: `0 ${height * 0.45}px`,
        borderRadius: height,
        background: "#B2FCE4",
        color: "#000",
        fontSize: height * 0.72,
        letterSpacing: "-0.02em",
        lineHeight: 1,
      }}
    >
      afterpay
    </span>
  );
}

/**
 * Compact Afterpay messaging line — "Or 4 interest-free payments of $X.XX with afterpay".
 *
 * variant="full" — used on the Product Detail page (larger, single line).
 * variant="compact" — used on product cards (short "4× $X.XX with afterpay").
 */
export default function AfterpayMessage({ price, variant = "full", className = "" }) {
  const amount = Number(price) || 0;
  if (amount <= 0) return null;
  const perInstallment = (amount / 4).toFixed(2);

  if (variant === "compact") {
    return (
      <span
        data-testid="afterpay-compact"
        className={`inline-flex items-center gap-1.5 text-[11px] text-[#757575] font-semibold ${className}`}
      >
        4 × ${perInstallment}
        <AfterpayLogo height={12} />
      </span>
    );
  }

  return (
    <div
      data-testid="afterpay-full"
      className={`inline-flex flex-wrap items-center gap-2 text-sm text-[#212121] ${className}`}
    >
      <span className="font-medium">
        Or 4 interest-free payments of <span className="font-black text-[#B87333]">${perInstallment}</span> with
      </span>
      <AfterpayLogo height={16} />
    </div>
  );
}

export { AfterpayLogo };
